import { TypeOutilPrelevement } from './enum/type-outil-prelevement';
import { ClasseVitesse } from '../Shared/classe-vitesse';
import { GPSPosition } from '../GPS-position';
import { SupportIBD } from './enum/support-IBD';
import { Ombre } from './enum/ombre';
import { IntensiteColmatage } from './enum/intensite-colmatage';
import { RecouvrementVegetal } from './recouvrement-vegetal';
import { PrelevementIBD } from './prelevement-ibd';

export class IBDProcess {
    Code: string;
    Outil: TypeOutilPrelevement;
    Support: SupportIBD;
    ClasseVitesse: ClasseVitesse;
    LmMoy: number;
    Ombrage: Ombre;
    IntensiteColmatage: IntensiteColmatage;
    CodeOutil: number;
    RecouvrementVegetal: RecouvrementVegetal = new RecouvrementVegetal();
    Prelevements: PrelevementIBD[] = [];
    Position: GPSPosition = new GPSPosition();

    constructor() { }

    static mapFromJSON(json): IBDProcess {
        const i = new IBDProcess();

        i.Code = json.code;
        i.Outil = json.outil;
        i.Support = json.support;
        i.ClasseVitesse = json.classeVitesse;
        i.LmMoy = json.lmMoy;
        i.Ombrage = json.ombrage;
        i.IntensiteColmatage = json.intensiteColmatage;
        i.CodeOutil = json.codeOutil;

        if (json.position) {
            i.Position = GPSPosition.mapFromJSON(json.position);
        }

        if (json.recouvrementVegetal) {
            i.RecouvrementVegetal = RecouvrementVegetal.mapFromJSON(json.recouvrementVegetal);
        }

        if (json.prelevements) {
            i.Prelevements = json.prelevements.map(jsonItem => PrelevementIBD.mapFromJSON(jsonItem));
        }

        return i;
    }
}
